module.exports = __webpack_public_path__ + "static/img/black-1.57311c87.png";